<input
  type="text"
  [placeholder]="placeholder()"
  [ngClass]="{ 'border-[#FF352D]': showError(), 'border-gray-300': !showError() }"
  class="barlow-regular w-full rounded-lg border-4 bg-white p-2 text-center text-2xl text-[#1A1A1A]"
/>
@if (showError()) {
  <div
    class="barlow-regular -mt-2 rounded-b-md bg-[#FF352D] py-1 text-center text-sm text-white"
    style="border-bottom-left-radius: 0.375rem; border-bottom-right-radius: 0.375rem"
  >
    {{ errorMessage() }}
  </div>
}
